import React from "react";
import { InputAdornment, MenuItem, Paper, Stack, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const ShippingCostFilters = ({ query, sortBy, onQueryChange, onSortChange }) => (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="stretch">
            <TextField
                placeholder="Suchen (Bezeichnung)"
                value={query}
                onChange={(event) => onQueryChange(event.target.value)}
                fullWidth
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchRoundedIcon />
                        </InputAdornment>
                    ),
                }}
            />
            <TextField
                select
                label="Sortierung"
                size="small"
                value={sortBy}
                onChange={(event) => onSortChange(event.target.value)}
                sx={{ minWidth: 220 }}
            >
                <MenuItem value="name-asc">Name A-Z</MenuItem>
                <MenuItem value="name-desc">Name Z-A</MenuItem>
                <MenuItem value="price-asc">Preis aufsteigend</MenuItem>
                <MenuItem value="price-desc">Preis absteigend</MenuItem>
            </TextField>
        </Stack>
    </Paper>
);

export default ShippingCostFilters;
